import generateBootFunc from '../../generate-boot';
import Index from './Components/Index.vue';

const bootIndex = generateBootFunc(Index, 'sprint-planning-index');

export {
    bootIndex
};